/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { OverlayModule } from '@angular/cdk/overlay';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AngularResizedEventModule } from 'angular-resize-event';
import { AngularSvgIconModule } from 'angular-svg-icon';
import {
  AccordionModule,
  BadgeModule,
  DatePickerModule,
  DirectivesModule,
  DropdownModule,
  EllipsisModule,
  FilterTagModule,
  ModalsModule,
  PipesModule,
  ScrollbarModule,
  SelectDropdownModule,
  SpinnerModule,
  SystemNotificationModule,
  TabsModule,
  TooltipModule
} from '@wfm/core';

import { VirtualGridComponent } from './virtual-grid/virtual-grid.component';
import { VirtualGridHeaderComponent } from './virtual-grid-header/virtual-grid-header.component';
import { VirtualGridHeaderDropdownComponent } from './virtual-grid-header-dropdown/virtual-grid-header-dropdown.component';
import { VirtualGridSettingsComponent } from './virtual-grid-settings/virtual-grid-settings.component';
import { VirtualGridLayoutComponent } from './virtual-grid-layout/virtual-grid-layout.component';
import { GenerateTemplatePipe } from './generate-template.pipe';
import { IsVirtualGridGroupPipe } from './is-virtual-grid-group.pipe';
import { VirtualGridCardFilterComponent } from './virtual-grid-card-filter/virtual-grid-card-filter.component';
import { VirtualGridCardSortComponent } from './virtual-grid-card-sort/virtual-grid-card-sort.component';
import { VirtualGridFilterTagPanelComponent } from './virtual-grid-filter-tag-panel/virtual-grid-filter-tag-panel.component';
import { GetPropertyValuePipe } from './get-property-value.pipe';
import { TagContainerStylePipe } from './virtual-grid-filter-tag-panel/tag-container-style.pipe';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { SetFilterPipe } from './set-filter.pipe';

@NgModule({
  declarations: [
    IsVirtualGridGroupPipe,
    GenerateTemplatePipe,
    GetPropertyValuePipe,
    TagContainerStylePipe,
    SetFilterPipe,
    VirtualGridComponent,
    VirtualGridCardFilterComponent,
    VirtualGridCardSortComponent,
    VirtualGridFilterTagPanelComponent,
    VirtualGridHeaderComponent,
    VirtualGridHeaderDropdownComponent,
    VirtualGridSettingsComponent,
    VirtualGridLayoutComponent
  ],
  exports: [
    VirtualGridComponent,
    VirtualGridCardFilterComponent,
    VirtualGridCardSortComponent,
    VirtualGridFilterTagPanelComponent,
    VirtualGridHeaderComponent,
    VirtualGridHeaderDropdownComponent,
    VirtualGridSettingsComponent,
    VirtualGridLayoutComponent
  ],
  entryComponents: [
    VirtualGridComponent,
    VirtualGridCardFilterComponent,
    VirtualGridCardSortComponent,
    VirtualGridFilterTagPanelComponent,
    VirtualGridHeaderComponent,
    VirtualGridHeaderDropdownComponent,
    VirtualGridSettingsComponent,
    VirtualGridLayoutComponent
  ],
  imports: [
    HttpClientModule,
    TranslateModule,
    AngularResizedEventModule,
    AngularSvgIconModule,
    AccordionModule,
    BadgeModule,
    CommonModule,
    DatePickerModule,
    DirectivesModule,
    DragDropModule,
    DropdownModule,
    EllipsisModule,
    FilterTagModule,
    FormsModule,
    ModalsModule,
    OverlayModule,
    PipesModule,
    ScrollingModule,
    ScrollbarModule,
    SelectDropdownModule,
    SpinnerModule,
    SystemNotificationModule,
    ModalsModule,
    FilterTagModule,
    TabsModule,
    TooltipModule
  ]
})
export class VirtualGridComponentsModule {}
